var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 55,
    viewBox: "0 0 48 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56813e-06 12.6373C7.56813e-06 19.5849 1.69637 42.2715 22.7479 54.6613C23.5211 55.1129 24.4789 55.1129 25.2521 54.6613C46.3036 42.2657 48 19.6022 48 12.6373C48 11.462 47.1807 10.4459 46.0325 10.2057C36.4082 8.20245 28.6419 2.89337 25.5002 0.50804C24.6145 -0.169347 23.3855 -0.169347 22.4998 0.50804C19.361 2.89337 11.5947 8.20245 1.96755 10.2057C0.819337 10.4459 -0.00287739 11.462 7.56813e-06 12.6373ZM13.5161 28.4777L15.247 26.7408C15.7288 26.2661 16.4991 26.2661 16.978 26.7408L19.8399 29.5256C20.3217 29.9975 21.0891 29.9975 21.5709 29.5256L33.3415 17.7148C33.8233 17.243 34.5907 17.243 35.0725 17.7148L36.8035 19.4517C37.2737 19.9351 37.2737 20.7052 36.8035 21.1886L21.5939 36.5774C21.1122 37.0493 20.3448 37.0493 19.863 36.5774L13.5161 30.2088C13.0487 29.7283 13.0487 28.9583 13.5161 28.4777Z",
    fill: "#08B1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.cf9706d863cedef824457d96025cd467.svg";
export { ForwardRef as ReactComponent };